<script lang="ts">
  import { sendEvent } from '../helpers/GoogleAnalytics';

  export let url: string;
  export let type: 'External' | 'Section' | 'Email' | 'Phone' | 'Page';
  export let selector = '';
  export let phoneGTM = {};

  function gmtEvent() {
    sendEvent('Click to call', phoneGTM);
  }
</script>

{#if type === 'External'}
  <a href={url} target={selector ? '_blank' : ''}>
    <slot />
  </a>
{/if}

{#if type === 'Section'}
  <a href="#{url}" target={selector ? '_blank' : ''}>
    <slot />
  </a>
{/if}

{#if type === 'Email'}
  <a href={`mailto:${url}`} target={selector ? '_blank' : ''}>
    <slot />
  </a>
{/if}

{#if type === 'Phone'}
  <a href={`tel:${url}`} target={selector ? '_blank' : ''} on:click={gmtEvent}>
    <slot />
  </a>
{/if}

{#if type === 'Page'}
  <a href={url} target={selector ? '_blank' : ''}>
    <slot />
  </a>
{/if}

<style>
  a {
    cursor: pointer;
    text-decoration: none;
    color: inherit;
  }
</style>
